// Local/default environment.
//
// The msal keys below MUST stay present even while empty. scripts/replace-env.js (run by the
// Dockerfile before `ng build`) injects the real values by regex-substituting into these existing
// keys — it cannot add keys that are missing. Stripping the msal block is what broke the
// production pipeline with "TS2339: Property 'msal' does not exist", because auth-config.ts reads
// environment.msal.* at compile time.
//
// Empty strings are safe to commit — no secrets here.
//
// For local development, fill these in with your own tenant values. NOTE this file IS tracked by
// git, so take care not to commit them: `git update-index --skip-worktree` on this file keeps your
// local edits out of `git status`. (environment.local.ts is gitignored and an .example for it
// exists, but nothing in angular.json or the app actually loads that file — the pattern was never
// wired up, so editing this file is currently the only way to configure local MSAL.)
export const environment = {
  production: false,
  apiUrl: 'https://resource-allocation-backend.azurewebsites.net/api',
  msal: {
    clientId: '49a0a4d7-c213-4247-858b-95b4c2990511',
    tenantId: 'd5e769b0-fd19-45e4-a4a8-b73545450234',
    apiScope: 'api://49a0a4d7-c213-4247-858b-95b4c2990511/access_as_user',
    adminGroupId: '97b68865-6525-46d1-96ae-4a06bab79884',
    pmGroupId: '6c8c3299-50dc-4d8e-801c-4b0ff5065c99',
    financeGroupId: 'a632a27d-c26f-4381-a7c9-1c7c902adf2b',
    softwareGroupId: 'f6922e8b-0cf1-41c6-926c-38e1a066f57d',
    pcGroupId: '839f3d53-80c6-447d-83c4-b085bc77d28e',
    accountingGroupId: '2f498909-042a-4987-be3d-08683fd282c7',
    marketingGroupId: '1efb20a8-949f-45e8-bd99-c75a3860ff82',
    salesGroupId: '083ca3ca-b63b-4ada-b6ba-998ee3f41b9e',
    itGroupId: '7352d504-0d9e-42c6-a460-dd6a0ad053dc',
    lndGroupId: '9235cbf2-9678-4985-ae34-22803616f05c',
    operationsGroupId: '98f67cba-e9ac-4d77-bdd5-51e189479eb7',
    supportGroupId: '6ee06a9c-7d82-46b8-8e67-b1c8675cdd4c'
  }
};
